// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.egradani_traka-holder {
  height: 86px;
  background: #eeeeee;
}
.egradani_traka-holder a {
  font-weight: normal;
}

.egradani_traka-holder.authenticated {
  height: 133px;
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/shared/layout/nias/nias-bar.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,mBAAA;AADF;AAGE;EACE,mBAAA;AADJ;;AAMA;EACE,aAAA;AAHF","sourcesContent":["@import 'edozvola-frontend-lib/dist/assets/css/00-settings/colors';\n\n.egradani_traka-holder {\n  height: 86px;\n  background: #eeeeee;\n\n  a {\n    font-weight: normal;\n  }\n\n}\n\n.egradani_traka-holder.authenticated {\n  height: 133px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
